import { Avatar, Button, Dialog, DialogContent, Grid, TextField, Typography } from '@mui/material';
import React, { useState } from 'react';
import MainCard from 'ui-component/cards/MainCard';
import User1 from 'assets/images/4811117-small.png';
import { Stack } from '@mui/system';
import ChangePasswordModal from './ChangePasswordModal';

const ProfileModal = ({ open, onClose, user }) => {
  const [changePasswordModalOpen, setChangePasswordModalOpen] = useState(false);

  const getRole = (role) => {
    let roleAsString = '';
    if (role === 'USER_ROLE') {
      roleAsString = 'Normal';
    } else if (role === 'ADMIN_ROLE') {
      roleAsString = 'Administrador';
    } else if (role === 'PM_ROLE') {
      roleAsString = 'Projec Manager';
    } else {
      roleAsString = 'Normal';
    }
    return roleAsString;
  };

  const handlerClose = () => {
    onClose(false);
  };

  const handleOpenChangePasswordModal = () => {
    setChangePasswordModalOpen(true);
  };

  const handleCloseChangePasswordModal = () => {
    setChangePasswordModalOpen(false);
  };

  return (
    <div>
      <Dialog open={open} onClose={onClose} maxWidth={'sm'} fullWidth>
        <DialogContent>
          <MainCard>
            <Stack alignItems="center" justifyContent="center" spacing={1}>
              <Grid>
                <Avatar marginLeft={10} src={User1} aria-haspopup="true" color="inherit" sx={{ width: 120, height: 120 }} />
              </Grid>
            </Stack>

            <Stack alignItems="center" justifyContent="center" spacing={1} marginBottom={4}>
              <Grid marginTop={2}>
                <Typography variant="h3" color="secondary">
                  {user.displayName}
                </Typography>
              </Grid>
              <Grid marginBottom={6}>
                <Typography variant="h5" color="secondary">
                  {getRole(JSON.parse(user?.reloadUserInfo?.customAttributes).role)}{' '}
                </Typography>
              </Grid>
            </Stack>

            <Grid container spacing={2}>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Correo electronico" type="text" value={user.email} inputProps={{ readOnly: true }} />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField fullWidth label="Numero de contacto" type="text" value={user.phoneNumber} inputProps={{ readOnly: true }} />
              </Grid>
            </Grid>
            <Grid container spacing={2} marginTop={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Dependecia"
                  type="text"
                  value={JSON.parse(user?.reloadUserInfo?.customAttributes).dependence}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} marginTop={1}>
              <Grid item xs={12} sm={12}>
                <TextField
                  fullWidth
                  label="Fecha de creación"
                  type="text"
                  value={user.metadata.creationTime}
                  inputProps={{ readOnly: true }}
                />
              </Grid>
            </Grid>
            <Stack alignItems="center" justifyContent="center" spacing={1} marginTop={2}>
              <Button onClick={handleOpenChangePasswordModal} variant="outlined">
                Cambiar Contraseña
              </Button>
            </Stack>
            <Stack alignItems="center" justifyContent="center" spacing={1} marginTop={4}>
              <Button onClick={handlerClose} variant="contained">
                OK
              </Button>
            </Stack>
          </MainCard>
        </DialogContent>
      </Dialog>
      <ChangePasswordModal open={changePasswordModalOpen} onClose={handleCloseChangePasswordModal} />
    </div>
  );
};

export default ProfileModal;
